import { Routes } from '@angular/router';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { authGuard } from './guards/auth.guard';
import { campaignAuthorizationGuard } from './guards/campaign-authorization.guard';
import { ShellComponent } from './layout/shell.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./features/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard, campaignAuthorizationGuard],
    children: [
      {
        path: '',
        redirectTo: 'campaigns',
        pathMatch: 'full',
      },
      {
        path: 'campaigns',
        loadComponent: () => import('./features/campaigns/campaigns.component').then((m) => m.CampaignsComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'campaigns',
  },
];
